<div class="prize-score">
    <!-- <h3 i18n>Prizes explained:</h3>
    <p class="list-title" i18n>Tournament position</p> -->
    <ul class="list">
        <li fxLayout="row" fxLayoutAlign="space-between center">
            <span i18n>
                Position
            </span>
            <span i18n>
                Prize
            </span>
        </li>
        <li *ngFor="let item of prizes; let i = index" fxLayout="row" fxLayoutAlign="space-between center">
            <span *ngIf="i > 2" class="after-three-position">
                {{item.position}}
            </span>
            <span *ngIf="i === 0">
                <img src="{{licenceService.getKey('icon-gold-cup-1')}}">
            </span>
            <span *ngIf="i === 1">
                <img src="{{licenceService.getKey('icon-gold-cup-2')}}">
            </span>
            <span *ngIf="i === 2">
                <img src="{{licenceService.getKey('icon-gold-cup-3')}}">
            </span>
            <span>
                {{item.name}}
            </span>
        </li>
    </ul>
</div>